var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{staticClass:"alert-feedback",attrs:{"color":_vm.feedback.color,"transition":"scale-transition","dark":"","value":_vm.feedback.feedback}},[_vm._v(_vm._s(_vm.feedback.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }